<template>
  <div>
    <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
      <app-main-sidebar></app-main-sidebar>
      <div id="page-content-wrapper" style="width:100%">
        <i
          class="material-icons"
          id="menu-toggle"
          @click="isSidebar = !isSidebar"
          style="cursor:pointer"
        >
          view_headline
        </i>
        <app-navbar></app-navbar>

        <div class="container-fluid mt-5">
          <div class="row mt-5">
            <div class="col-sm-12">
              <vs-breadcrumb
                align="left"
                :items="[
                  { title: 'You are here : ' },
                  {
                    title: 'Dashboard',
                    url: '/#/dashboard/trainee/traineeDashboard'
                  },
                  {
                    title: 'Knowledge Base',
                    active: true
                  }
                ]"
              ></vs-breadcrumb>
              <div class="frm-title pl-0">
                <div class="heading mt-3">
                  <h3 class="text-secondary-2 text-left">
                    Knowledge / Training Material
                  </h3>
                </div>
              </div>
            </div>
          </div>

          <div class="row mt-2">
            <div class="col-md-4 mb-3">
              <section class="events-panel">
                <div class="events-panel__header">
                  <div>
                    <h5>Trainings</h5>
                    <small>
                      <b>({{ filteredTrainings.length }} available)</b>
                    </small>
                  </div>
                  <span class="events-panel__pill">Materials</span>
                </div>
                <div class="events-panel__search">
                  <input
                    type="text"
                    placeholder="Search trainings..."
                    v-model="searchQuery"
                    class="events-panel__search-input"
                  />
                </div>
                <div class="events-panel__list">
                  <article
                    class="event-card"
                    v-for="element in filteredTrainings"
                    :key="element.training.id"
                    :class="{ 'event-card--active': active_tr === element.training.id }"
                    @click="handleTrainingSelect(element)"
                  >
                    <div class="event-card__accent"></div>
                    <div class="event-card__desktop">
                      <div class="event-card__top">
                        <div>
                          <h6>{{ element.training.title }}</h6>
                          <p class="event-card__code">
                            {{ element.training.training_code }}
                          </p>
                        </div>
                        <i class="material-icons">play_circle_fill</i>
                      </div>
                      <div class="event-card__meta">
                        <span v-if="element.training.startdate">
                          Start: {{ formattedDate(element.training.startdate) }}
                        </span>
                        <span v-if="element.training.enddate">
                          End: {{ formattedDate(element.training.enddate) }}
                        </span>
                      </div>
                    </div>
                    <div class="event-card__mobile">
                      <div class="event-card__mobile-top">
                        <h6>{{ element.training.title }}</h6>
                        <p class="event-card__code">{{ element.training.training_code }}</p>
                      </div>
                      <div class="event-card__mobile-meta" v-if="element.training.startdate">
                        <span>Start: {{ formattedDate(element.training.startdate) }}</span>
                        <span class="event-card__mobile-separator"></span>
                        <span>End: {{ formattedDate(element.training.enddate) }}</span>
                      </div>
                    </div>
                  </article>
                  <div v-if="!filteredTrainings.length" class="events-panel__empty">
                    No trainings found
                  </div>
                </div>
              </section>
            </div>

            <div class="col-md-8 mb-3" v-if="selectedTraining" ref="materialsPanel">
              <div class="materials-panel">
                <div class="materials-panel__header">
                  <div>
                    <h5>{{ selectedTraining.title }}</h5>
                    <small v-if="selectedTraining.startdate">
                      <b>
                        Start Date : {{ formattedDate(selectedTraining.startdate) }}
                        <span v-if="selectedTraining.enddate">
                          &nbsp;End Date : {{ formattedDate(selectedTraining.enddate) }}
                        </span>
                      </b>
                    </small>
                    <p v-if="selectedTraining.venue">
                      <b>{{ selectedTraining.venue }} ({{ selectedTraining.address }})</b>
                    </p>
                  </div>
                  <div class="materials-panel__actions">
                    <span class="materials-panel__badge" v-if="allMaterials.length">
                      {{ allMaterials.length }} item{{ allMaterials.length > 1 ? 's' : '' }}
                    </span>
                    <span class="materials-panel__badge materials-panel__badge--warning" v-else>
                      No materials yet
                    </span>
                  </div>
                </div>

                <div class="materials-body">
                  <aside class="materials-filter">
                    <button
                      v-for="filter in filters"
                      :key="filter.key"
                      class="materials-filter__btn"
                      :class="{ 'materials-filter__btn--active': activeFilter === filter.key }"
                      @click="setFilter(filter.key)"
                    >
                      {{ filter.label }}
                    </button>
                  </aside>
                  <div class="materials-content">
                    <section
                      class="material-section detail-card__step"
                      v-for="section in displayedSections"
                      :key="section.key"
                    >
                      <header class="material-section__header">
                        <div>
                          <h6>{{ section.title }}</h6>
                          <small v-if="section.key !== 'certificate'">
                            {{ section.items.length }} item{{ section.items.length > 1 ? 's' : '' }}
                          </small>
                        </div>
                        <span
                          v-if="section.key === 'certificate'"
                          class="status-pill"
                          :class="section.locked ? 'status-pill--warning' : 'status-pill--success'"
                        >
                          {{ section.locked ? 'Post Assessment Pending' : 'Unlocked' }}
                        </span>
                      </header>
                      <div v-if="section.items.length" class="material-list">
                        <article
                          class="material-item"
                          v-for="item in section.items"
                          :key="item.id || `${item.title}-${item.uploadfile || item.link}`"
                        >
                          <div class="material-item__meta">
                            <h6>{{ item.title }}</h6>
                            <small>{{ item.createdAt | formatDate }}</small>
                          </div>
                          <a
                            v-if="item.fileType !== 'Weblink'"
                            class="material-item__action"
                            :href="`${BASEPATHDYNAMIC}/${item.uploadfile}`"
                            target="_blank"
                          >
                            <i class="material-icons">download</i>
                            Download
                          </a>
                          <a
                            v-else
                            class="material-item__action"
                            :href="formatWeblink(item.link)"
                            target="_blank"
                          >
                            <i class="material-icons">open_in_new</i>
                            Visit Link
                          </a>
                        </article>
                      </div>
                      <div v-else class="material-empty">
                        {{ section.emptyMessage }}
                      </div>
                    </section>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-8 mb-3" v-else ref="materialsPanel">
              <div class="materials-panel empty-panel">
                Select a training to view its materials.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from "./Navbar";
import mainSidebar from "./main-sidebar";
import axios from "axios";

export default {
  data: () => ({
    isSidebar: false,
    trainings: [],
    allMaterialArr: [],
    certFilter: [],
    BASEPATHDYNAMIC: "",
    active_tr: 0,
    trainingId: "",
    selectedTraining: null,
    searchQuery: "",
    postAssessmentComplete: false,
    activeFilter: "all",
    filters: [
      { key: "all", label: "Show All" },
      { key: "ppt", label: "Presentations" },
      { key: "word", label: "Word" },
      { key: "pdf", label: "PDF" },
      { key: "link", label: "Html Links" },
      { key: "video", label: "Videos" },
      { key: "image", label: "Images" },
      { key: "certificate", label: "Certificates" },
    ],
  }),
  components: {
    "app-navbar": Navbar,
    "app-main-sidebar": mainSidebar,
  },
  mounted() {
    axios.defaults.headers["Authorization"] = localStorage.getItem("token");
    this.BASEPATHDYNAMIC = process.env.VUE_APP_BASE_PATH;
    this.fetchTrainings();
  },
  computed: {
    filteredTrainings() {
      if (!this.searchQuery.trim()) {
        return this.trainings;
      }
      const query = this.searchQuery.toLowerCase();
      return this.trainings.filter((entry) =>
        (entry.training.title || "").toLowerCase().includes(query)
      );
    },
    allMaterials() {
      return this.allMaterialArr.filter((item) => item.fileType !== "Certificate");
    },
    materialSections() {
      return [
        {
          key: "all",
          title: "All",
          items: this.allMaterials,
          emptyMessage: "No materials found.",
        },
        {
          key: "ppt",
          title: "Presentations",
          items: this.filterMaterials("PPT"),
          emptyMessage: "No presentations found.",
        },
        {
          key: "word",
          title: "Word Documents",
          items: this.filterMaterials("Word"),
          emptyMessage: "No Word documents found.",
        },
        {
          key: "pdf",
          title: "PDF Files",
          items: this.filterMaterials("PDF"),
          emptyMessage: "No PDF files found.",
        },
        {
          key: "link",
          title: "Web Links",
          items: this.filterMaterials("Weblink"),
          emptyMessage: "No links found.",
        },
        {
          key: "video",
          title: "Videos",
          items: this.filterMaterials("Video"),
          emptyMessage: "No videos found.",
        },
        {
          key: "image",
          title: "Images",
          items: this.filterMaterials("Image"),
          emptyMessage: "No images found.",
        },
      ];
    },
    certificateSection() {
      return {
        key: "certificate",
        title: "Certificates",
        items: this.postAssessmentComplete ? this.certFilter : [],
        locked: !this.postAssessmentComplete,
        emptyMessage: this.postAssessmentComplete
          ? "No certificates found."
          : "Complete the post assessment to unlock certificate downloads.",
      };
    },
    displayedSections() {
      if (this.activeFilter === "certificate") {
        return [this.certificateSection];
      }
      const section =
        this.materialSections.find((sec) => sec.key === this.activeFilter) ||
        this.materialSections.find((sec) => sec.key === "all");
      return section ? [section] : [];
    },
  },
  methods: {
    formattedDate(dateString) {
      if (!dateString) {
        return "";
      }
      const parts = dateString.split("-");
      if (parts.length === 3) {
        return `${parts[2]}-${parts[1]}-${parts[0]}`;
      }
      return dateString;
    },
    formatWeblink(link) {
      if (!link) return "#";
      return /^https?:\/\//i.test(link) ? link : `//${link}`;
    },
    fetchTrainings() {
      this.openLoading();
      axios
        .get(
          `${process.env.VUE_APP_BASE_PATH}/get/all/trainee/training/${
            JSON.parse(localStorage.getItem("currentUser")).id
          }`
        )
        .then((response) => {
          if (response.data?.unAuth) {
            this.handleUnauthorized(response.data.unAuth);
            return;
          }
          if (response.data?.tokenExpired) {
            this.handleUnauthorized(response.data.tokenExpired);
            return;
          }
          this.trainings = response.data || [];
          if (this.trainings.length) {
            this.handleTrainingSelect(this.trainings[0]);
          }
        })
        .finally(() => {
          this.closeLoading();
        });
    },
    handleTrainingSelect(entry) {
      if (!entry || !entry.training) return;
      this.active_tr = entry.training.id;
      this.trainingId = entry.training.id;
      this.selectedTraining = entry.training;
      this.trainingMaterialsLoad(this.trainingId);
      this.fetchTrainingStatus(this.trainingId);
      this.scrollToMaterials();
    },
    trainingMaterialsLoad(id) {
      if (!id) return;
      this.openLoading();
      axios
        .get(`${process.env.VUE_APP_BASE_PATH}/trainingmaterils/knowledgebase/get/${id}`)
        .then((response) => {
          if (response.data?.unAuth) {
            this.handleUnauthorized(response.data.unAuth);
            return;
          }
          if (response.data?.tokenExpired) {
            this.handleUnauthorized(response.data.tokenExpired);
            return;
          }
          this.allMaterialArr = response.data || [];
        })
        .finally(() => {
          this.closeLoading();
        });
    },
    fetchTrainingStatus(id) {
      const traineeId = JSON.parse(localStorage.getItem("currentUser")).id;
      axios
        .get(
          `${process.env.VUE_APP_BASE_PATH}/trainee/check/assesments/all/${id}/${traineeId}`
        )
        .then((response) => {
          if (response.data?.unAuth) {
            this.handleUnauthorized(response.data.unAuth);
            return;
          }
          if (response.data?.tokenExpired) {
            this.handleUnauthorized(response.data.tokenExpired);
            return;
          }
          this.postAssessmentComplete = !!response.data?.checkPostAssesment;
          if (this.postAssessmentComplete) {
            this.loadCertificate();
          } else {
            this.certFilter = [];
          }
        });
    },
    loadCertificate() {
      if (!this.postAssessmentComplete || !this.trainingId) {
        this.certFilter = [];
        return;
      }
      this.openLoading();
      axios
        .get(
          `${process.env.VUE_APP_BASE_PATH}/trainee/knowledgebase/certificate/get/${this.trainingId}/${
            JSON.parse(localStorage.getItem("currentUser")).id
          }`
        )
        .then((response) => {
          if (response.data?.unAuth) {
            this.handleUnauthorized(response.data.unAuth);
            return;
          }
          if (response.data?.tokenExpired) {
            this.handleUnauthorized(response.data.tokenExpired);
            return;
          }
          this.certFilter = response.data || [];
        })
        .finally(() => {
          this.closeLoading();
        });
    },
    filterMaterials(type) {
      return this.allMaterialArr.filter((item) => item.fileType === type);
    },
    setFilter(key) {
      this.activeFilter = key;
      if (key === "certificate" && this.postAssessmentComplete && !this.certFilter.length) {
        this.loadCertificate();
      }
    },
    scrollToMaterials() {
      if (typeof window === "undefined" || window.innerWidth > 768) {
        return;
      }
      this.$nextTick(() => {
        const panel = this.$refs.materialsPanel;
        if (panel && typeof panel.scrollIntoView === "function") {
          panel.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      });
    },
    handleUnauthorized(message) {
      this.$toasted?.global?.errorMsg?.(message || "Unauthorized");
      localStorage.clear();
      setTimeout(() => {
        this.$router.push("/");
      }, 1000);
    },
    openLoading() {
      this.$vs.loading({
        type: "material",
      });
    },
    closeLoading() {
      this.$vs.loading.close();
    },
  },
};
</script>

<style scoped>
#menu-toggle {
  display: none;
}

@media (max-width: 768px) {
#menu-toggle {
    display: block;
  }
}

.events-panel {
  background: #ffffff;
  border-radius: 18px;
  padding: 1.5rem;
  height: 100%;
  min-height: 85vh;
  max-height: 85vh;
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  box-shadow: 0 20px 40px rgba(6, 166, 224, 0.12);
  border: 1px solid rgba(6, 166, 224, 0.2);
}

.events-panel__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
}

.events-panel__header h5 {
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 0.2em;
  font-size: 0.95rem;
}

.events-panel__header small b {
  font-size: 0.8rem;
  color: #5f5f5f;
}

.events-panel__pill {
  background: linear-gradient(135deg, #06a6e0, #64d5f3);
  color: white;
  padding: 0.4rem 0.75rem;
  border-radius: 999px;
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.05em;
}

.events-panel__search-input {
  width: 100%;
  border-radius: 12px;
  border: 1px solid rgba(6, 166, 224, 0.35);
  padding: 0.65rem 1rem;
  font-size: 0.9rem;
  outline: none;
  transition: border-color 0.3s ease, box-shadow 0.3s ease;
}

.events-panel__search-input:focus {
  border-color: #06a6e0;
  box-shadow: 0 0 0 2px rgba(6, 166, 224, 0.2);
}

.events-panel__list {
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.events-panel__empty {
  text-align: center;
  color: #6b6b6b;
  padding: 2rem 0;
}

.event-card {
  position: relative;
  background: #f8fbff;
  border-radius: 16px;
  padding: 1.1rem 1.2rem 1.2rem 2rem;
  border: 1px solid rgba(6, 166, 224, 0.15);
  cursor: pointer;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.event-card--active {
  transform: translateY(-2px);
  box-shadow: 0 15px 30px rgba(6, 166, 224, 0.25);
}

.event-card__accent {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 6px;
  border-radius: 16px 0 0 16px;
  background: linear-gradient(180deg, #06a6e0 0%, #0078b5 100%);
}

.event-card__desktop {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.event-card__top {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.event-card__desktop h6 {
  margin: 0;
  font-size: 1rem;
  color: #0c2f5c;
}

.event-card__code {
  font-size: 0.8rem;
  color: #6b6b6b;
  margin: 0.1rem 0 0;
}

.event-card__desktop i.material-icons {
  color: #06a6e0;
  font-size: 28px;
}

.event-card__meta {
  display: flex;
  justify-content: space-between;
  font-size: 0.8rem;
  color: #536275;
}

.event-card__mobile {
  display: none;
  flex-direction: column;
  gap: 0.6rem;
}

.event-card__mobile-top h6 {
  margin: 0;
  color: #0a2a51;
}

.event-card__mobile-meta {
  display: flex;
  justify-content: space-between;
  font-size: 0.85rem;
  color: #475569;
  align-items: center;
}

.event-card__mobile-separator {
  flex: 1;
  border-bottom: 1px dashed rgba(71, 85, 105, 0.3);
  margin: 0 0.5rem;
}

@media (max-width: 768px) {
  .events-panel {
    min-height: auto;
    max-height: none;
    padding: 1rem;
  }

  .event-card__desktop {
    display: none;
  }

  .event-card__mobile {
    display: flex;
  }
}

.materials-panel {
  border-radius: 26px;
  border: none;
  padding: 1.75rem;
  box-shadow: 0 25px 45px rgba(6, 166, 224, 0.18);
  min-height: 85vh;
  background: linear-gradient(145deg, #f4fbff 0%, #ffffff 60%, #e6f4ff 100%);
}

.materials-panel__header {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  flex-wrap: wrap;
}

.materials-panel__header h5 {
  margin: 0;
  font-size: 1.6rem;
  font-weight: 600;
}

.materials-panel__header small b {
  color: #5b6c82;
}

.materials-panel__actions {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.materials-panel__badge {
  background: rgba(6, 166, 224, 0.15);
  color: #0369a1;
  padding: 0.35rem 0.9rem;
  border-radius: 999px;
  font-weight: 600;
  font-size: 0.8rem;
}

.materials-panel__badge--warning {
  background: rgba(251, 191, 36, 0.2);
  color: #b45309;
}

.materials-grid {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 1.5rem;
}

.materials-body {
  display: flex;
  gap: 1.5rem;
  margin-top: 1.25rem;
}

.materials-filter {
  flex: 0 0 160px;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.materials-filter__btn {
  border: 1px solid rgba(6, 166, 224, 0.2);
  border-radius: 12px;
  padding: 0.45rem 0.75rem;
  background: #fff;
  font-size: 0.85rem;
  font-weight: 600;
  text-align: left;
  color: #0c2f5c;
  transition: background 0.3s ease, color 0.3s ease, border-color 0.3s ease;
}

.materials-filter__btn--active {
  background: linear-gradient(135deg, #06a6e0, #3fb3ff);
  color: #fff;
  border-color: transparent;
}

.materials-content {
  flex: 1;
}

.material-section {
  width: 100%;
  border-radius: 16px;
  background: #ffffff;
  border: 1px solid rgba(6, 166, 224, 0.22);
  padding: 1rem;
  box-shadow: 0 10px 24px rgba(6, 166, 224, 0.12);
}

.material-section__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.75rem;
}

.material-section__header h6 {
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
}

.material-section__header small {
  color: #5f6b80;
}

.material-list {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.material-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.85rem 1rem;
  border-radius: 12px;
  border: 1px solid rgba(6, 166, 224, 0.15);
  background: #f8fbff;
}

.material-item__meta h6 {
  margin: 0;
  font-size: 0.95rem;
  font-weight: 600;
}

.material-item__meta small {
  color: #6c7a90;
}

.material-item__action {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  font-size: 0.75rem;
  font-weight: 600;
  color: #06a6e0;
}

.material-item__action i {
  font-size: 18px;
}

.material-empty {
  text-align: center;
  padding: 1.25rem;
  color: #9ca3af;
  font-weight: 500;
}

.status-pill {
  border-radius: 999px;
  padding: 0.35rem 0.85rem;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
}

.status-pill--success {
  background: rgba(34, 197, 94, 0.2);
  color: #15803d;
}

.status-pill--warning {
  background: rgba(251, 191, 36, 0.2);
  color: #b45309;
}

.empty-panel {
  min-height: 85vh;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  color: #64748b;
}

@media (max-width: 768px) {
  .materials-panel {
    min-height: auto;
    padding: 1.25rem;
  }

  .materials-body {
    flex-direction: column;
  }

  .materials-filter {
    flex-direction: row;
    flex-wrap: wrap;
  }

  .materials-filter__btn {
    flex: 1 1 calc(50% - 0.5rem);
    text-align: center;
  }

  .material-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }

  .material-item__action {
    width: 100%;
    justify-content: center;
  }
}
</style>
